import React from 'react';
import { HG } from './HG';
import { Link } from './Link';

export const Footer = () => {
    return (
        <HG style={{ padding: '12px', fontSize: '12px', color: '#2b2b2b' }}>
            <div style={{ flex: 1 }}>
                by <Link href="https://loopme.com/">LoopMe LTD</Link>
            </div>
            <div style={{ flex: 5 }}>
                Follow us on <Link href="https://twitter.com/loopme">Twitter</Link> and{' '}
                <Link href="https://www.facebook.com/LoopMeMedia/">Facebook</Link>
            </div>
            <div>
                &copy; LoopMe LTD / All rights reserved /{' '}
                <Link href="https://legal.loopme.com/privacy-center">Privacy Policy</Link>
            </div>
        </HG>
    );
};
